import { Config } from './config';
import { getRandomNumber } from './utils';
var GameEngine = /** @class */ (function () {
    function GameEngine(canvas, players) {
        this.interval = 0;
        this.stepsUntilHolePerPlayer = new Map();
        this.holeSizePerPlayer = new Map();
        this.speed = Config.pixelsPerSecond * (1000 / Config.fps / 1000);
        this.playerRanks = [];
        this.canvasContext = canvas;
        this.players = players;
    }
    GameEngine.prototype.prepare = function () {
        var _this = this;
        if (this.interval) {
            return new Promise(function (resolve) { return resolve([]); });
        }
        return new Promise(function (resolve, reject) {
            _this.resolveCallback = resolve;
            _this.playerRanks = [];
            // Start drawing first few pixels so everybody knows his start position
            _this.draw();
            _this.draw();
            _this.draw();
            _this.draw();
        });
    };
    GameEngine.prototype.start = function () {
        var _this = this;
        if (!this.interval) {
            this.interval = window.setInterval(function () {
                _this.draw();
            }, 1000 / Config.fps);
        }
    };
    GameEngine.prototype.stop = function () {
        clearInterval(this.interval);
        this.interval = 0;
        if (this.resolveCallback) {
            this.resolveCallback(this.playerRanks);
        }
    };
    GameEngine.prototype.draw = function () {
        var _this = this;
        this.players
            .filter(function (player) {
            return player.isActive && player.isAlive;
        })
            .forEach(function (player) {
            if (player.isTurningLeft) {
                player.angle -= Config.angleModifier;
            }
            if (player.isTurningRight) {
                player.angle += Config.angleModifier;
            }
            var deltaX = Math.cos(player.angle * Math.PI / 180) * _this.speed;
            var deltaY = Math.sin(player.angle * Math.PI / 180) * _this.speed;
            if (_this.hitTest({ x: player.xPosition + deltaX, y: player.yPosition + deltaY })) {
                _this.playerRanks.unshift(player);
                player.isAlive = false;
                var alivePlayers = _this.players.filter(function (player) {
                    return player.isAlive;
                });
                if (alivePlayers.length < 2) {
                    alivePlayers.forEach(function (player) {
                        _this.playerRanks.unshift(player);
                    });
                    _this.stop();
                }
            }
            if (!_this.stepsUntilHolePerPlayer.has(player.id)) {
                _this.stepsUntilHolePerPlayer.set(player.id, _this.getStepsUntilNextHole());
            }
            if (_this.stepsUntilHolePerPlayer.get(player.id) === 0) {
                if (!_this.holeSizePerPlayer.has(player.id)) {
                    _this.holeSizePerPlayer.set(player.id, 0);
                }
                else {
                    var holeSize = (_this.holeSizePerPlayer.get(player.id) || 0) + 1;
                    _this.holeSizePerPlayer.set(player.id, holeSize);
                    if (holeSize >= Config.holeSize) {
                        _this.stepsUntilHolePerPlayer.set(player.id, _this.getStepsUntilNextHole());
                        _this.holeSizePerPlayer.set(player.id, 0);
                    }
                }
            }
            else {
                _this.stepsUntilHolePerPlayer.set(player.id, (_this.stepsUntilHolePerPlayer.get(player.id) || 1) - 1);
                _this.canvasContext.strokeStyle = player.color;
                _this.canvasContext.fillStyle = player.color;
                _this.canvasContext.beginPath();
                _this.canvasContext.lineWidth = Config.lineWidth;
                _this.canvasContext.moveTo(player.xPosition, player.yPosition);
                _this.canvasContext.lineTo(player.xPosition + deltaX, player.yPosition + deltaY);
                _this.canvasContext.stroke();
            }
            player.xPosition += deltaX;
            player.yPosition += deltaY;
        });
    };
    GameEngine.prototype.getStepsUntilNextHole = function () {
        return Math.floor(getRandomNumber(1, 100) * (100 / Config.holeFrequency));
    };
    GameEngine.prototype.hitTest = function (point) {
        if (point.x > Config.canvasWidth || point.y > Config.canvasHeight || point.x < 0 || point.y < 0) {
            return true;
        }
        if (this.canvasContext.getImageData(point.x, point.y, 1, 1).data[3] > 100) {
            return true;
        }
        return false;
    };
    return GameEngine;
}());
export { GameEngine };
